import { z } from "zod";
// ============================================================================
// Word Translation — Request / Response schemas
// ============================================================================
export const TranslateWordPayloadSchema = z.object({
    word: z.string().min(1).max(100),
    sentence: z.string().min(1).max(500),
    targetLanguage: z.enum(["en", "uk", "ru", "de"]),
    direction: z.enum(["from_de", "to_de"]).default("from_de"),
    context: z.string().max(500).optional(),
    exercise_id: z.number().optional(),
});
export const TranslateWordResponseSchema = z.object({
    word_translation: z.string(),
    sentence_translation: z.string(),
    word_base_form: z.string().optional(),
    part_of_speech: z.string().optional(),
    /** For reverse translations: dictionary form in the source language (e.g. "плохой" when user clicked "плохая") */
    source_base_form: z.string().optional(),
    present_er: z.string().optional(),
    prateritum: z.string().optional(),
    perfekt: z.string().optional(),
    gender: z.string().optional(),
    plural: z.string().optional(),
    no_plural: z.boolean().optional(),
    audio_url: z.string().optional(),
    category: z.string().optional(),
    cefr_level: z.string().optional(),
    governance: z.string().optional(),
});
